window.slate = window.slate || {};
window.theme = window.theme || {};

history.navigationMode = 'compatible';

theme.URLParams = {
  set: function (key, value) {
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    history.replaceState(null, '', url);
  },

  get: function (key) {
    const url = new URL(window.location.href);
    return url.searchParams.get(key);
  },

  delete: function (key) {
    const url = new URL(window.location.href);
    url.searchParams.delete(key);
    history.replaceState(null, '', url);
  },

  has: function (key) {
    const url = new URL(window.location.href);
    return url.searchParams.has(key);
  }
};

theme.isIpad = function() {
  return navigator.userAgent.match(/iPad/i) != null;
}

/*================ Mobile Check ================*/
theme.isMobile = function() {
  return $(window).width() <= 768;
};

function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

var currentCart = '';

theme.GoToCheckout = function() {
  window.location.href = "/cart/"+currentCart;
};

theme.internationalOnly = function() {
  if(country == 'US') {
    $('.international-only').hide();
  } else {
    $('.international-only').show();
  }
};

theme.PromoCartPopup = function() {
  $.magnificPopup.open({
    items: {
      src: '#cart-promo-popup',
      type: 'inline'
    },
    mainClass: 'mfp-with-zoom',
    midClick: true,
    removalDelay: 500,
    closeOnBgClick: true,
    callbacks: {
      open: function() {
        $('.cart-preloader').fadeOut();
        $('#fake-checkout').addClass('fake-checkout-ready');
      }
    }
  }, 0);
};
theme.InternationalCartPopup = function() {
  $.magnificPopup.open({
    items: {
      src: '#international-upsell',
      type: 'inline'
    },
    mainClass: 'mfp-with-zoom',
    midClick: true,
    removalDelay: 500,
    closeOnBgClick: false,
    callbacks: {
      open: function() {
        $('.cart-preloader').fadeOut();
        $('#fake-checkout').addClass('fake-checkout-ready');
      }
    }
  }, 0);
};
theme.DomesticCartPopup = function() {
  $.magnificPopup.open({
    items: {
      src: '#domestic-upsell',
      type: 'inline'
    },
    mainClass: 'mfp-with-zoom',
    midClick: true,
    removalDelay: 500,
    closeOnBgClick: false,
    callbacks: {
      open: function() {
        $('.cart-preloader').fadeOut();
        $('#fake-checkout').addClass('fake-checkout-ready');
      }
    }
  }, 0);
};
var selectedCProducts = 0,
    maxCProducts = 2,
    SampleArray = [],
    country = 'US';

$(function() {

  console.log(Cookies.get('_shopify_country'));

  if(Cookies.get('igCountry') === 'US') {
    $('.us--only').fadeIn();
  } else {
    $('.int--only').fadeIn();
  }


  $('.site-nav__mega-shop .mega_links a').mouseenter(function() {
    var img = $(this).data('image'),
        $img = $('.site-nav__mega-shop .mega-dropdown_image img');
    if(img != $img.attr('src')) {
      $img.attr('src',img);
    }
  });

  theme.dbAjaxForm();
  if(getUrlParameter('product-faq') != '') {
    $('.general-preloader').fadeIn();
  }


});



/*================ Cart Note ==============*/
theme.saveCartNote = function() {
  if($('#CartSpecialInstructions').val() != '') {
    Cookies.set('cartNote', $('#CartSpecialInstructions').val());
  }
};

theme.getCartNote = function() {
  if(Cookies.get('cartNote') != undefined) {
    $('#CartSpecialInstructions').val(Cookies.get('cartNote'));
  }
};

theme.mfpSetup = function() {
  $(document).on('click','.mfp-inline',function() {
    var href = $(this).attr('href');
    $.magnificPopup.open({
      items: {
        src: href
      },
      type: 'inline'
    }, 0);

  });
};

/*================ Samples ==============*/


theme.getCountry = function() {
  country = $('#countrySelect').val();
  $('.selected-country').text(country);
};



/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
    .attr('tabIndex', '-1')
    .focus()
    .addClass(focusClass)
    .one('blur', callback);

    function callback() {
      $element.first()
      .removeClass(focusClass)
      .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};



/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
  .on('shopify:section:load', this._onSectionLoad.bind(this))
  .on('shopify:section:unload', this._onSectionUnload.bind(this))
  .on('shopify:section:select', this._onSelect.bind(this))
  .on('shopify:section:deselect', this._onDeselect.bind(this))
  .on('shopify:section:reorder', this._onReorder.bind(this))
  .on('shopify:block:select', this._onBlockSelect.bind(this))
  .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);


    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
    //console.log($(evt.target).attr('id'));
    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
      //console.log('run onSelect');
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

function floatToString(e, t) {
  var n = e.toFixed(t).toString();
  return n.match(/^\.\d+/) ? "0" + n : n
}

function attributeToString(e) {
  return "string" != typeof e && (e += "", "undefined" === e && (e = "")), jQuery.trim(e)
}

"undefined" == typeof window.Shopify && (window.Shopify = {}),

Shopify.money_format = "${{amount_no_decimals}}",

Shopify.onError = function(e, t) {
  var n = eval("(" + e.responseText + ")");
  n.message ? console.log(n.message + "(" + n.status + "): " + n.description) : console.log("Error : " + Shopify.fullMessagesFromErrors(n).join("; ") + ".")
},

Shopify.fullMessagesFromErrors = function(e) {
  var t = [];
  return jQuery.each(e, function(e, n) {
    jQuery.each(n, function(n, r) {
      t.push(e + " " + r)
    })
  }), t
},

Shopify.onCartShippingRatesUpdate = function(e, t) {
  var n = "";
  t.zip && (n += t.zip + ", "), t.province && (n += t.province + ", "), n += t.country, console.log("There are " + e.length + " shipping rates available for " + n + ", starting at " + Shopify.formatMoney(e[0].price) + ".")
},

Shopify.updateCartOnAdd = function() {
  $.get('/cart', function(data) {
    $('.top-cart').html($(data).find('.top-cart').html());
    $('.mobile-cart-count').html($(data).find('.mobile-cart-count').html());
  });
  $.magnificPopup.close();
};

Shopify.onItemAdded = function(e) {
  if (window.location.href.indexOf("/cart") > -1) {
    theme.saveCartNote();
    $.get('/cart', function(data) {

    }).done(function() {
      theme.mfpSetup();
    });
  } else {
    Shopify.updateCartOnAdd();
  }
},

Shopify.onProduct = function(e) {

},

Shopify.formatMoney = function(e, t) {
  function n(e, t) {
    return "undefined" == typeof e ? t : e
  }

  function r(e, t, r, i) {
    if (t = n(t, 2), r = n(r, ","), i = n(i, "."), isNaN(e) || null == e) return 0;
    e = (e / 100).toFixed(t);
    var o = e.split("."),
        a = o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + r),
        s = o[1] ? i + o[1] : "";
    return a + s
  }
  "string" == typeof e && (e = e.replace(".", ""));
  var i = "",
      o = /\{\{\s*(\w+)\s*\}\}/,
      a = t || this.money_format;
  switch (a.match(o)[1]) {
    case "amount":
      i = r(e, 2);
      break;
    case "amount_no_decimals":
      i = r(e, 0);
      break;
    case "amount_with_comma_separator":
      i = r(e, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      i = r(e, 0, ".", ",")
  }
  return a.replace(o, i)
},

Shopify.resizeImage = function(e, t) {
  try {
    if ("original" == t) return e;
    var n = e.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
    return n[1] + "_" + t + "." + n[2]
  } catch (r) {
    return e
  }
},

Shopify.addItems = function(items_arr) {
  $.post('/cart/add.js', { items: items_arr }, function(e) {
    console.log(e);
    location.reload();
  });
},

Shopify.addItem = function(e, t, n) {
  var t = t || 1,
      r = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + t + "&id=" + e,
        dataType: "json",
        success: function(e) {
          "function" == typeof n ? n(e) : Shopify.onItemAdded(e)
        },
        error: function(e, t) {
          Shopify.onError(e, t);
          //console.log('error');
        }
      };
  jQuery.ajax(r)
},

Shopify.addItemFromForm = function(e, t) {
  var n = {
    type: "POST",
    url: "/cart/add.js",
    data: jQuery("#" + e).serialize(),
    dataType: "json",
    success: function(e) {
      "function" == typeof t ? t(e) : Shopify.onItemAdded(e)
    },
    error: function(e, t) {
      Shopify.onError(e, t)
    }
  };
  jQuery.ajax(n)
},

Shopify.getCart = function(e) {
  jQuery.getJSON("/cart.js", function(t, n) {
    "function" == typeof e ? e(t) : Shopify.onCartUpdate(t)
  })
},

Shopify.pollForCartShippingRatesForDestination = function(e, t, n) {
  n = n || Shopify.onError;
  var r = function() {
    jQuery.ajax("/cart/async_shipping_rates", {
      dataType: "json",
      success: function(n, i, o) {
        200 === o.status ? "function" == typeof t ? t(n.shipping_rates, e) : Shopify.onCartShippingRatesUpdate(n.shipping_rates, e) : setTimeout(r, 500)
      },
      error: n
    })
  };
  return r
},

Shopify.getCartShippingRatesForDestination = function(e, t, n) {
  n = n || Shopify.onError;
  var r = {
    type: "POST",
    url: "/cart/prepare_shipping_rates",
    data: Shopify.param({
      shipping_address: e
    }),
    success: Shopify.pollForCartShippingRatesForDestination(e, t, n),
    error: n
  };
  jQuery.ajax(r)
},

Shopify.getProduct = function(e, t) {
  jQuery.getJSON("/products/" + e + ".js", function(e, n) {
    "function" == typeof t ? t(e) : Shopify.onProduct(e)
  })
},

  Shopify.changeItem = function(e, t, n) {
  var r = {
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + t + "&id=" + e,
    dataType: "json",
    success: function(e) {
      "function" == typeof n ? n(e) : Shopify.onCartUpdate(e)
    },
    error: function(e, t) {
      Shopify.onError(e, t)
    }
  };
  jQuery.ajax(r)
},

  Shopify.removeItem = function(e, t) {
  var n = {
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=0&id=" + e,
    dataType: "json",
    success: function(e) {
      "function" == typeof t ? t(e) : Shopify.onCartUpdate(e)
    },
    error: function(e, t) {
      Shopify.onError(e, t)
    }
  };
  jQuery.ajax(n)
},

  Shopify.clear = function(e) {
  var t = {
    type: "POST",
    url: "/cart/clear.js",
    data: "",
    dataType: "json",
    success: function(t) {
      "function" == typeof e ? e(t) : Shopify.onCartUpdate(t)
    },
    error: function(e, t) {
      Shopify.onError(e, t)
    }
  };
  jQuery.ajax(t)
},
  Shopify.updateCartFromForm = function(e, t) {
  //$('.cart-preloader').show();
  var n = {
    type: "POST",
    url: "/cart/update.js",
    data: jQuery("#" + e).serialize(),
    dataType: "json",
    success: function(e) {
      "function" == typeof t ? t(e) : Shopify.onCartUpdate(e)
    },
    error: function(e, t) {
      Shopify.onError(e, t)
      console.log('updateCartFromForm Error');
      console.log(e,t);
      window.location.href='/cart';
    }
  };
  jQuery.ajax(n);
},

  Shopify.updateCartAttributes = function(e, t) {
  var n = "";
  jQuery.isArray(e) ? jQuery.each(e, function(e, t) {
    var r = attributeToString(t.key);
    "" !== r && (n += "attributes[" + r + "]=" + attributeToString(t.value) + "&")
  }) : "object" == typeof e && null !== e && jQuery.each(e, function(e, t) {
    n += "attributes[" + attributeToString(e) + "]=" + attributeToString(t) + "&"
  });
  var r = {
    type: "POST",
    url: "/cart/update.js",
    data: n,
    dataType: "json",
    success: function(e) {
      "function" == typeof t ? t(e) : Shopify.onCartUpdate(e)
    },
    error: function(e, t) {
      Shopify.onError(e, t)
    }
  };
  jQuery.ajax(r)
},

  Shopify.updateCartNote = function(e, t) {
  var n = {
    type: "POST",
    url: "/cart/update.js",
    data: "note=" + attributeToString(e),
    dataType: "json",
    success: function(e) {
      "function" == typeof t ? t(e) : Shopify.onCartUpdate(e)
    },
    error: function(e, t) {
      Shopify.onError(e, t)
    }
  };
  jQuery.ajax(n)
}, jQuery.fn.jquery >= "1.4" ? Shopify.param = jQuery.param : (Shopify.param = function(e) {
  var t = [],
      n = function(e, n) {
        n = jQuery.isFunction(n) ? n() : n, t[t.length] = encodeURIComponent(e) + "=" + encodeURIComponent(n)
      };
  if (jQuery.isArray(e) || e.jquery) jQuery.each(e, function() {
    n(this.name, this.value)
  });
  else
    for (var r in e) Shopify.buildParams(r, e[r], n);
  return t.join("&").replace(/%20/g, "+")
},

                                                               Shopify.buildParams = function(e, t, n) {
  jQuery.isArray(t) && t.length ? jQuery.each(t, function(t, r) {
    rbracket.test(e) ? n(e, r) : Shopify.buildParams(e + "[" + ("object" == typeof r || jQuery.isArray(r) ? t : "") + "]", r, n)
  }) : null != t && "object" == typeof t ? Shopify.isEmptyObject(t) ? n(e, "") : jQuery.each(t, function(t, r) {
    Shopify.buildParams(e + "[" + t + "]", r, n)
  }) : n(e, t)
},
                                                               Shopify.isEmptyObject = function(e) {
  for (var t in e) return !1;
  return !0
});


theme.Hero = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Hero(container) {
    this.$container = $(container);
    //console.log('hero');

  }

  Hero.prototype = $.extend({}, Hero.prototype, {

  });

  return Hero;
})();

theme.HeroPromo = (function() {
  function Hero(container) {
    this.$container = $(container);
    this.$container.fitVids();
  }

  Hero.prototype = $.extend({}, Hero.prototype, {
    onLoad: function() {
      this.$container.fitVids();
    }
  });

  return Hero;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

theme.dbAjaxForm = function() {
  var selectors = {
    formId: '#db-ajax-contact-form',
    messages: '#db-ajax-form-messages'
  }
  var responses = {
    success: "Thank You! Your message has been sent.",
    error: "Uh oh! Something has gone terribly wrong."
  }
  $(selectors.formId).submit(function(event) {
    event.preventDefault();
    var formData = $(selectors.formId).serialize();
    $.ajax({
      type:'POST',
      url: $(selectors.formId).attr('action'),
      data: formData
    })
    .done(function(response) {
      //$(selectors.formId).hide();
      $(selectors.messages).removeClass('error');
      $(selectors.messages).addClass('success');

      // Set the message text.
      $(selectors.messages).text(responses.success);

      $(selectors.formId).find('.btn-brown').hide();

      // Clear the form.
      $('.db-input').val('');
    })
    .fail(function(data) {
      // Make sure that the formMessages div has the 'error' class.
      $(selectors.messages).removeClass('success');
      $(selectors.messages).addClass('error');

      $(selectors.messages).text(responses.error);
    });
  });
};

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

document.addEventListener('DOMContentLoaded', function () {
  theme.customerLogin = (function () {
    var config = {
      recoverPasswordLink: '#RecoverPassword',
      recoverPasswordForm: '#RecoverPasswordForm',
      hideRecoverPasswordLink: '#HideRecoverPasswordLink',
    };

    if (!document.querySelector(config.recoverPasswordLink) || !document.querySelector(config.recoverPasswordForm)) {
      return;
    }

    checkUrlHash();
    resetPasswordSuccess();

    document.querySelector(config.recoverPasswordLink).addEventListener('click', onShowHidePasswordForm);
    document.querySelector(config.hideRecoverPasswordLink)?.addEventListener('click', onShowHidePasswordForm);

    function onShowHidePasswordForm(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    }

    function checkUrlHash() {
      var hash = window.location.hash;
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }

    function toggleRecoverPasswordForm() {
      document.querySelector(config.recoverPasswordForm)?.classList.toggle('hide');
      document.querySelector('#CustomerLoginForm')?.classList.toggle('hide');
    }

    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');
      if (!formState) {
        return;
      }
      document.querySelector('#ResetSuccess')?.classList.remove('hide');
    }
  })();
});

//add simple support for background images:
document.addEventListener('lazybeforeunveil', function(e){
  var bg = e.target.getAttribute('data-bg');
  if(bg){
    e.target.style.backgroundImage = 'url(' + bg + ')';
  }
});

if($(window).width() > 768) {
  isMobile = false;
} else {
  isMobile = true;
}

var OwlArrowNext = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" viewBox="0 0 68 68.5" xml:space="preserve"><polygon points="44.9 34 23.9 0 23.1 0.5 43.9 34.3 23.1 68 23.9 68.5 44.9 34.5 44.5 34.3 " fill="#4D4D4D"/></svg>';
var OwlArrowPrev = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" viewBox="0 0 68 68.5" xml:space="preserve"><polygon points="23.1 34.5 44.1 68.5 44.9 68 24.1 34.3 44.9 0.5 44.1 0 23.1 34 23.5 34.3 " fill="#4D4D4D"/></svg>';

$.extend(jQuery.easing,{myEase:function(x,t,b,c,d){return -c *(t/=d)*(t-2) + b;}});

$.fn.extend({
  toggleText: function(a, b){
    return this.text(this.text() == b ? a : b);
  }
});

/* Let's set up some Section Events */
theme.showAllSliders = function() {
  $('#the-index-hero-promo--wrapper').fadeIn();
  $('#the-index-hero--wrapper').fadeIn();
}

theme.heroEvents = function(evt) {
  console.log(evt.target.id);
  var owl = $( ".the-index-hero-carousel");
  if( owl.length )
  {
    switch ( evt.originalEvent.type ) {
      case "shopify:section:select" :
        console.log(evt.target);
        $(evt.target).fadeIn();
        break;
      case "shopify:section:load" :
        //console.log('Load ' + owl.attr("id"));
        owl.on('initialized.owl.carousel',function(event) {
          var element = $(event.target);
          owl.show().css('opacity','1').css('visibility','visible');
        });

        owl.owlCarousel({
          loop:true,
          margin: 0,
          nav: false,
          lazyLoad: false,
          dots: true,
          items: 1,
          navText: [
            OwlArrowPrev,
            OwlArrowNext
          ]
        });
        break;
      case "shopify:section:unload" :
        break;
    }
  }
}

$(function() {
  $(document).on('shopify:section:load', function(e) {
    theme.heroEvents(e);
  });
  $(document).on('shopify:section:select', theme.showAllSliders);
  $(document).on('shopify:section:deselect',function() {
    $.magnificPopup.close();
  });
  $(document).on('shopify:section:select',function(e) {
    if(e.detail.sectionId == "template--15159210148027__popups") {
      if(window.country == 'US') {
        theme.DomesticCartPopup();
      } else {
        theme.InternationalCartPopup();
      }
    }
    if(e.detail.sectionId == 'promo-popup') {
      $.magnificPopup.open({
        items: {
          src: '#promo-popup'
        },
        type: 'inline',
        removalDelay: 300,
        mainClass: 'mfp-with-zoom',
        closeOnBgClick: true
      });
    }
  });
});

theme.checkGiftWrap = function() {
  if($('#cart-table').attr('data-remove-gift-wrap') == "true") {
    console.log('Remove gift wrap');
    anythingToDo = true;
    $('.gift-wrapping-product .quantity').val(0);
    $('.cart__update').trigger('click');
  }
};


/* General Site Javascript */
$(document).ready(function() {
  $('.product-thumb__link').on('click',function(e) {
    var idx = $(this).data('thumb-index');
    $('.product-thumb__link').removeClass('active');
    $(this).addClass('active');
    wick.goToSlide('.product-carousel',idx);
    return false;
  });

  $('.rituals-switcher').on('change',function() {
    window.location.href = $(this).val();
  });

  $('.youtube-iframe__wrapper .play-btn').on('click',function(e) {
    e.preventDefault();
    var $t = $(this).closest('.youtube-iframe__wrapper'),
        $iframe = $t.find('iframe'),
        $playBtn = $t.find('.play-btn'),
        mySrc = $iframe.data('src');

    if($iframe.hasClass('is--playing')) {
      $iframe.removeClass('is--playing');
      wick.pauseYoutube($iframe);
      $playBtn.fadeTo('slow',1);
    } else {
      $iframe.addClass('is--playing');
      wick.playYoutube($iframe);
      $playBtn.fadeTo('slow',0);
    }
    return false;
  });

  //Hideables
  $.each(hideables,function(index,value) {
    var handle = value.split(' ').join('-').toLowerCase();
    $('#featured-in-carousel a[href*="'+handle+'"]').closest('div').remove();
  });

  if(!$('body').hasClass('template-cart')) {
    localStorage.setItem('cartNote','');
    Cookies.remove('cartNote');
  }

  $(document).on('click','.cart__update',function(e) {
    e.preventDefault();
    Shopify.updateCartFromForm('the-cart-form');
  });

  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('index-hero',theme.Hero);
  sections.register('index-hero-promo',theme.HeroPromo);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
      '.rte iframe[src*="youtube.com/embed"],' +
      '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  if($('.the-index-hero-carousel').length) {
    var owl = $('.the-index-hero-carousel');

    owl.on('initialized.owl.carousel',function(event) {
      var element = $(event.target);
      owl.show().css('opacity','1').css('visibility','visible');
    });

    owl.owlCarousel({
      loop:true,
      margin: 0,
      nav: false,
      lazyLoad: false,
      autoHeight: true,
      dots: true,
      items: 1,
      navText: [
        OwlArrowPrev,
        OwlArrowNext
      ]
    });
  }
  if($('#the-wk-heroz').length) {
    var owl = $('#the-wk-hero');

    owl.on('initialized.owl.carousel',function(event) {
      var element = $(event.target);
      owl.show().css('opacity','1').css('visibility','visible');
    });

    owl.owlCarousel({
      loop:true,
      margin: 0,
      nav: false,
      lazyLoad: false,
      autoHeight: true,
      dots: true,
      items: 1,
      navText: [
        OwlArrowPrev,
        OwlArrowNext
      ]
    });
  }

  $(document.links).filter(function() {
    if(this.hostname != 'returns.maylindstrom.com') {
      return this.hostname != window.location.hostname;
    }
  }).attr('target', '_blank')

  if($('#ingredients-carousel').length) {
    var owl = $('#ingredients-carousel');

    owl.owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      dots: false,
      responsive:{
        0:{
          items: 2,
        },
        600:{
          items: 4
        }
      },
      navText: [
        OwlArrowPrev,
        OwlArrowNext
      ]
    });
  }



  if($('#featured-in-carousel').length) {
    var owl = $('#featured-in-carousel');
    owl.owlCarousel({
      loop:true,
      margin: 0,
      nav: true,
      lazyLoad: false,
      dots: false,
      items: 1,
      navText: [
        OwlArrowPrev,
        OwlArrowNext
      ]
      //startPosition: randomized

    });
  }



  if($('#ingredients-tab-mobile-carousel').length) {
    var owl = $('#ingredients-tab-mobile-carousel');
    owl.owlCarousel({
      loop:true,
      margin: 0,
      nav: true,
      lazyLoad: false,
      dots: false,
      items: 1,
      navText: [
        OwlArrowPrev,
        OwlArrowNext
      ]
    });
  }


  if($('#mobile-testimonials-slideshow').length) {
    var owl = $('#mobile-testimonials-slideshow');
    owl.owlCarousel({
      loop:true,
      margin: 0,
      nav: true,
      lazyLoad: false,
      dots: false,
      autoHeight: true,
      items: 1,
      navText: [
        OwlArrowPrev,
        OwlArrowNext
      ]
    });
  }


  if($('#product-mobile-carousel').length) {
    var owl = $('#product-mobile-carousel');
    owl.owlCarousel({
      loop:true,
      margin: 0,
      nav: true,
      lazyLoad: false,
      dots: false,
      items: 1,
      navText: [
        OwlArrowPrev,
        OwlArrowNext
      ]
    });
  }

  $(document).on('click','.int-shipping-link',function(e) {
    e.preventDefault();
    $('#int-shipping').fadeIn();
    $('html,body').animate({
      scrollTop: ($('#int-shipping').offset().top - $('#shopify-section-header > div').outerHeight())
    }, 500);
  });

  $(document).on('click','.inline-link',function(e) {
    e.preventDefault();
    var target = $(this).attr('href');
    $('html,body').animate({
      scrollTop: ($(target).offset().top - $('#shopify-section-header > div').outerHeight())
    }, 500);
  });

  $('.faq .answer a').attr('target','_blank');

  $(document).on('click','.faq .question',function(e) {
    e.preventDefault();
    $(this).toggleClass('open').next().slideToggle(500,'myEase');
  });

  var SideMenuOpen = false;

  $('.side-has-sub > a').click(function(e) {
    if($(this).parent().parent().hasClass('sub-sub-side-menu') || $(this).parent().hasClass('tolink')) {
    } else {
      e.preventDefault();
    }
    $(this).siblings('.sub-side-menu').slideToggle('fast','myEase');
    $(this).parent().toggleClass('open');
  });

  $('.trigger-menu').click(function(e) {
    e.preventDefault();
    $('html').toggleClass('is--locked');
    if($('#side-menu').hasClass('open')) {
      $('#side-menu').removeClass('open');
      $('#body-cover').fadeOut();
      $('#nav-toggle').removeClass('open');
      SideMenuOpen = false;
    } else {
      $('#side-menu').addClass('open');
      $('#body-cover').fadeIn();
      $('#nav-toggle').addClass('open');
      SideMenuOpen = true;
    }
  });

  

  $(document).on('click','.has-kids',function(e) {
    e.preventDefault();
    $(this).toggleClass('open').next().slideToggle('fast','myEase').toggleClass('open');
  });

  if($('.collection-sidebar li.active').length) {
    $('.collection-sidebar li.active').parent().prev().trigger('click');
  }

  $(document).on('click', '.add-to-cart', function(e) {
    e.preventDefault();

    var btn = $(this);

    // Prevent execution if the button has the class 'GiftWizard-gift-button'
    if (btn.hasClass('GiftWizard-gift-button')) {
        return;
    }

    var old_btn_txt = btn.find('span').text();
    var new_btn_txt = old_btn_txt.replace('Add', 'Added');
    var time = 3000;
    var form = btn.parents('form').attr('id');

    var selectedVariantId = $('#' + form).find('select[name="id"]').val();
    console.log('Selected variant ID:', selectedVariantId);

    var formData = $('#' + form).serialize();
    console.log('Form data:', formData);

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
        enableLoading();
        cartDrawer.show();

        const cartDrawerEmpty = cartDrawer.querySelector('.cart-drawer-empty-msg');
        if (cartDrawerEmpty) {
            cartDrawerEmpty.classList.add('hidden-el');
        }
    }

    Shopify.addItemFromForm(form, function(cart) {
        console.log('Item added to cart from form:', cart);
        btn.prop('disabled', true).find('span').text(new_btn_txt);

        setTimeout(function() {
            btn.prop('disabled', false).find('span').text(old_btn_txt);
        }, time);
        
        const event = new CustomEvent('addtocart');
        document.dispatchEvent(event);
    });
  });

  $('.close-added-popup').on('click',function(e) {
    e.preventDefault();
    $(this).parent().fadeOut();

  });

  if(isMobile) {
    $('.sample-preview-link').on('click',function(e) {
      e.preventDefault();
      $(this).next().stop().fadeToggle();
      $(this).toggleText('+','-');
    });
  } else {
    $('.sample-preview-link').hover(
      function() {
        $(this).next().stop().fadeIn('fast','myEase');
      },function() {
        $(this).next().stop().fadeOut('fast','myEase');
      }
    );
  }

  ajaxMailChimpForm($("#newsletter-popup-form"), $("#newsletter-popup-responses"));
  ajaxMailChimpForm($("#newsletter-contact-form"), $("#newsletter-contact-responses"));

  // Turn the given MailChimp form into an ajax version of it.
  // If resultElement is given, the subscribe result is set as html to
  // that element.
  function ajaxMailChimpForm($form, $resultElement){
    // Hijack the submission. We'll submit the form manually.
    $form.submit(function(e) {
      e.preventDefault();
      if (!isValidEmail($form)) {
        var error =  "A valid email address must be provided.";
        $resultElement.html(error);
        //$resultElement.css("color", "white");
        $resultElement.fadeIn();
      } else {
        $resultElement.fadeIn();
        //$resultElement.css("color", "white");
        $resultElement.html("Subscribing...");
        submitSubscribeForm($form, $resultElement);
      }
    });
  }
  // Validate the email address in the form
  function isValidEmail($form) {
    // If email is empty, show error message.
    // contains just one @
    var email = $form.find("input[type='email']").val();
    if (!email || !email.length) {
      return false;
    } else if (email.indexOf("@") == -1) {
      return false;
    }
    return true;
  }

  var ajaxChimpURL = '//maylindstrom.us8.list-manage.com/subscribe/post-json?c=?';

  function submitSubscribeForm($form, $resultElement) {
    $.ajax({
      type: "GET",
      url: ajaxChimpURL,
      data: $form.serialize(),
      cache: false,
      dataType: "json",
      //jsonp: "c", // trigger MailChimp to return a JSONP response
      contentType: "application/json; charset=utf-8",
      error: function(error){
        // According to jquery docs, this is never called for cross-domain JSONP requests
        //console.log(error);
      },
      success: function(data){
        if (data.statusText != "success") {
          var message = data.msg || "Sorry. Unable to subscribe. Please try again later.";
          if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
            message = "You're already subscribed. Thank you.";
          }
          $resultElement.html(message);
        } else {
          $resultElement.html("Thank you!<br>You must confirm the subscription in your inbox.");
        }
      }
    });
  }

  function addAllItems(array,returnText){
    Shopify.queue = [];
    //var quantity = {{ cart.item_count }} ;
    var newArray = array.split(',');
    for (var i = 0; i < newArray.length; i++) {
      product = newArray[i]
      Shopify.queue.push({
        variantId: product,
      });
    }
    Shopify.moveAlong = function() {
      if (Shopify.queue.length) {
        var request = Shopify.queue.shift();
        var data = 'id='+ request.variantId + '&quantity=1'
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: data,
          success: function(res){
            Shopify.moveAlong();
            Shopify.onItemAdded();
          },
          error: function(e,t){
            if (Shopify.queue.length){
              Shopify.moveAlong()
            } else {
              Shopify.onItemAdded();
            }
          }
        });
      }
      else {
        $('.add-all').text(returnText);
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          enableLoading();
          cartDrawer.show();
          const cartDrawerEmpty = cartDrawer.querySelector('.cart-drawer-empty-msg');
          if (cartDrawerEmpty) {
            cartDrawerEmpty.classList.add('hidden-el');
          }
        }
        const event = new CustomEvent('addtocart');
        document.dispatchEvent(event);
      }
    };
    Shopify.moveAlong();
  };

  $(document).on('click','.add-all',function(e) {
    e.preventDefault();
    $('.close-added-popup').trigger('click');
    var $t = $(this);
    var currentText = $t.text();
    $t.text('Adding...');
    var all_products = $t.data('products');
    addAllItems(all_products, currentText);
    return false;
  });

  $('.ritual-options a').on('click',function() {
    var $t = $(this),
        $r = $($t.data('ritual'));

    smoothScrollTo($r);
    return false;
  });

  $('.mfp-inline').magnificPopup({
    type: 'inline',
    midClick: true,
    removalDelay: 500,
    mainClass: 'mfp-with-zoom'
  });

  $('.mfp-video').magnificPopup({
    type: 'iframe',
    midClick: true,
    removalDelay: 500,
    mainClass: 'mfp-with-zoom'
  });

  $('.mfp-inline-gallery').magnificPopup({
    type: 'inline',
    midClick: true,
    removalDelay: 500,
    mainClass: 'mfp-with-zoom',
    gallery: {
      enabled: true
    },
    callbacks: {
      buildControls: function() {
        this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
      }
    }
  });

  $('.mfp-gallery').magnificPopup({
    type: 'image',
    gallery: {
      enabled: true
    },
    removalDelay: 500,
    mainClass: 'mfp-with-zoom bts-gallery'
  });

  $('.mfp-gallery-link').on('click',function(e) {
    e.preventDefault();
    $('.mfp-gallery').eq(0).trigger('click');
  });

  $('#honey-mud-notice__link').magnificPopup({
    type: 'inline',
    midClick: true,
    removalDelay: 500,
    mainClass: 'mfp-with-zoom'
  });

  $('#chocolate-box-notice__link').magnificPopup({
    type: 'inline',
    midClick: true,
    removalDelay: 500,
    mainClass: 'mfp-with-zoom'
  });

  $(document).on('click','.honey-mud-notice__trigger',function(e) {
    e.preventDefault();
    $('#honey-mud-notice__link').trigger('click');
  });

  $(document).on('click','.chocolate-box-notice__trigger',function(e) {
    e.preventDefault();
    console.log('this');
    $('#chocolate-box-notice__link').trigger('click');
  });

  $('#product-image').hover(
    function() {
      var newImage = $(this).find('img').data('hover-img');
      $(this).find('img').attr('src',newImage);
    }, function() {
      var oldImage = $(this).find('img').data('original-img');
      $(this).find('img').attr('src',oldImage);
    }
  );

  $('.qty-plus').on('click',function(e) {
    e.preventDefault();
    var val = Number($('.qty-number').val());
    if(val < 50) {
      $('.qty-number').val(val+1);
    }
  });

  $('.qty-minus').on('click',function(e) {
    e.preventDefault();
    var val = Number($('.qty-number').val());
    if(val > 1) {
      $('.qty-number').val(val-1);
    }
  });

  $('.fitvids').fitVids();

  $('.product-tab-header').on('click',function(e) {
    $('.product-tab-header').removeClass('active');
    $(this).addClass('active');
    e.preventDefault();
    var newTab = $($(this).attr('href'));
    $('.product-tab').hide();
    newTab.fadeIn()
  });

  $('#faq-tab h3').on('click',function(e) {
    e.preventDefault();

    $(this).toggleClass('active').next().slideToggle('fast','myEase');
  });

  //Also change in the Add Bar
  

  $('#product-add-bar #add-bar-dd').on('change',function(e) {
    var normalID = '#'+$(this).val().replace('add-bar-','');

    $(normalID).trigger('click');
  });

  $("#product-add-bar .add-to-cart").on('click', function(e) {
    e.preventDefault();
    $('#product-info .add-to-cart').trigger('click');
    const event = new CustomEvent('addtocart');
    document.dispatchEvent(event);
    Shopify.updateCartOnAdd();
});

  function QtySubtract(obj) {
    var qtyInput = $(obj).siblings('.quantity');
    var current_value = parseInt(qtyInput.val());
    var next_value = current_value - 1;

    qtyInput.val(next_value);
    $('.cart__update').trigger('click');
  }
  function QtyAdd(obj) {
    var qtyInput = $(obj).siblings('.quantity');
    var current_value = parseInt(qtyInput.val());

    var next_value = current_value;
    if(current_value < 9) {
      var next_value = current_value + 1;
    }
    qtyInput.val(next_value);
    $('.cart__update').trigger('click');
  }

  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  
  $(document).on('click', '.quick-add', function(e) {
    e.preventDefault();
    const productId = $(this).data('product-id');
    
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
        enableLoading();
        cartDrawer.show();
        const cartDrawerEmpty = cartDrawer.querySelector('.cart-drawer-empty-msg');
        if (cartDrawerEmpty) {
            cartDrawerEmpty.classList.add('hidden-el');
        }
    }

    Shopify.addItem(productId, 1, debounce(function(cart) {
      if (productId == "452620941") {
        $.magnificPopup.close();
      }
      const event = new CustomEvent('addtocart');
      document.dispatchEvent(event);
    }, 100));
  });

  $(document).on('click','.remove-item',function(e) {
    $(this).parents('.line-item').fadeOut('fast');
    var id = $(this).data('variant-id');
    Shopify.removeItem(id);
  });

  $(document).on('click','.load-more-testimonials', function(e) {
    e.preventDefault();
    $(this).parent().hide();
    $(this).parent().next().slideDown().next().fadeIn();
  });

  SquareImages();

  Resizing();

  theme.isMobile();

  if(!theme.isMobile()) {
    $(document).on('mouseenter','.promo--question',function(e) {
      e.preventDefault();
      $('.promo--info').addClass('show');
    });
    $(document).on('mouseleave','.promo--question-wrapper',function(e) {
      e.preventDefault();
      $('.promo--info').removeClass('show');
    });
  }

  $(document).on('click','#igSplashElement .close',function() {
    setTimeout(promoPopup, 5000);
  });

  if(Cookies.get('igSplash') == 'igSplash') {
    promoPopup();
  }

  if(Cookies.get('igCountry' == 'US')) {
    promoPopup();
  }
  promoPopup();

  $(document).on('shopify:section:select',function(e) {
    console.log(e.detail.sectionId, $('#promo-popup').length);
    if(e.detail.sectionId == 'promo-popup' && $('#promo-popup').length) {
      console.log('open the promo popup');
      $.magnificPopup.open({
        items: {
          src: '#promo-popup'
        },
        type: 'inline',
        removalDelay: 300,
        mainClass: 'mfp-with-zoom',
        closeOnBgClick: true
      });
    }
  });
  $(document).on('shopify:section:deselect',function(e) {
    if(e.target.id == 'promo-popup') {
      $.magnificPopup.close();
    }
  });

  function promoPopup()  {
    var waitTime = 3;
    var timer = waitTime * 1000;


    if($('body').hasClass('template-index')) {
      return;
    }
    if($('body').hasClass('template-cart')) {
      return;
    }
    if($('body').hasClass('template-collection') && window.location.href.indexOf('shop-all') > -1) {
      return;
    }
    if(window.location.href.indexOf('rise-ai-giftcard') > -1) {
      return;
    }

    if (window.theme.promoEngaged && Cookies.get('promo-popup') != 'seen it' && window.theme.promoPopup) {
      let scrollPosition = 0;

      setTimeout(function() {
        $.magnificPopup.open({
          items: {
            src: '#promo-popup'
          },
          type: 'inline',
          removalDelay: 300,
          mainClass: 'mfp-with-zoom',
          closeOnBgClick: true,
          callbacks: {
            open: function() {
              var inFifteenMinutes = new Date(new Date().getTime() + 30 * 60 * 1000);

              Cookies.set('promo-popup', 'seen it', {
                expires: 14
              });

              scrollPosition = window.pageYOffset;

              document.body.style.position = "fixed";
              document.body.style.top = `-${scrollPosition}px`;
              document.body.style.width = "100%";
            },
            close: function() {
              document.body.style.removeProperty('overflow');
              document.body.style.removeProperty('position');
              document.body.style.removeProperty('top');
              document.body.style.removeProperty('width');

              window.scrollTo(0, scrollPosition);
            }
          }
        }, 0);
      }, timer );
    }
  }

  $(document).on('click','.promo-popup-close',function(e) {
    e.preventDefault();
    $.magnificPopup.close();
  });

  $(document).on('change','#countrySelect',function(e) {
    var country = $(this).val();
    theme.internationalOnly();
  });

  if (!$('body').hasClass('template-cart')) {
    Cookies.remove('cartNote');
  }

  $('.share-story-btn').on('click',function(e) {
    e.preventDefault();
  });

  $('.share-story--submit').on('click',function(e) {
    e.preventDefault();
    /* Build the Shopify Parameters
	//---------------------------------------*/
    var action  = '/pages/share-your-story?';
    action += encodeURIComponent('form_type') +'='+ encodeURIComponent('contact');
    action += '&'+ encodeURIComponent('utf8') +'='+ encodeURIComponent('✓');
    action += '&'+ encodeURIComponent('contact[email]') +'='+ encodeURIComponent(contact_email);
    action += '&'+ encodeURIComponent('contact[body]') +'='+ encodeURIComponent(contact_body);

    /* Submit the form
	//---------------------------------------*/
    $.ajax({
      type: "POST",
      async: true,
      url: action,
      error: function(jqXHR, textStatus, errorThrown) {
        //  Request Failed.
      },
      success: function(response) {
        console.log(response);
        // Assume Success. 'response' is the complete HTML page of the
        // contact success form, so likely won't be helpful
        self.submit_thankyou();
      }
    });
  });
});

function openHoneyMudNotice() {
  $('#honey-mud-notice__link').trigger('click');
}

//Throttled scroll listener
$(window).scroll( $.throttle( 100, function() {
  var headerDiv = $('#shopify-section-header');
  var y = $(this).scrollTop();
  if(y > headerDiv.height()) {
    headerDiv.addClass('collapse');
  } else {
    headerDiv.removeClass('collapse');
  }

  if(y > (headerDiv.height() + $('#product-top-level').height())) {
    $('#product-add-bar').addClass('show-add-bar');
  } else {
    $('#product-add-bar').removeClass('show-add-bar');
  }

  var ajaxhref = false;
  var paged = false;

  if($('.pagination').length) {
    if($('.pagination').visible() && paged == false) {

      var ajaxhref = $('.pagination .next').attr('href');
      $('.pagination').remove();
      //console.log('boo');
      $.get(ajaxhref, function(data) {
        paged = true;
        var newCollection = $(data).find('.collection-grid').html();
        var newPagination = $(data).find('.pagination').html();
        $('.collection-grid').append(newCollection);
        $('.pagination').html(newPagination);
        paged = false;
      });
    }
  }
  $('.ritual-single__video').each(function() {
    var $t = $(this);
    wick.inView($t, false) ? wick.playVideo($t) : wick.pauseVideo($t);
  });
}));

function Resizing() {
  $('.product-ingredient .rte').matchHeight();
}

function SquareImages() {
  if($(window).width() > 1280) {
    $('#meet-may-section .image').height($('#meet-may-section .image').width());
    $('#concern-header .image').height($('#concern-header .image').width());
    $('#contact-page .image').height($('#contact-page .image').width());
  } else {
    $('#meet-may-section .image').height('auto');
    $('#concern-header .image').height('auto');
    $('#contact-page .image').height('auto');
  }
}


function smoothScrollTo(target) {
  var scrollTopAdjusted = target.offset().top - $('.shopify-section-header').height() - $('#product-tabs-header').height();
  target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
  if(!$('#product-add-bar').hasClass('show-add-bar')) {
    scrollTopAdjusted = scrollTopAdjusted - $('#product-add-bar').height() + 7;
    console.log('excuse me, but your add bar is NOT showing',scrollTopAdjusted);
  }
  if (target.length) {
    $('html,body').animate({
      scrollTop: scrollTopAdjusted
    }, 1000);
  }
}


$(window).load(function() {
  if(window.location.href.indexOf('?product-faq') > 0) {
    $('#product-add-bar').addClass('show-add-bar');
    $('.product-tab-header.faq-header').trigger('click');
    setTimeout(function() {

      smoothScrollTo($('#product-tabs'));
    }, 250);
  }

  if(getUrlParameter('product-faq') != undefined) {
    var target = '#' + getUrlParameter('product-faq');
    if($(target).length) {
      $('.product-tab-header.faq-header').trigger('click');
      setTimeout(function() {
        $('.general-preloader').fadeOut();
        $(target).find('h3').trigger('click');
        smoothScrollTo($(target));
      },500);
    }
  }

  $('#mobile-shop-by-trigger').on('click',function(e) {
    e.preventDefault();
    $('#mobile-shop-by').slideToggle('fast');
  });

  Resizing();

  if(getUrlParameter('clearcookies') != '' || getUrlParameter('cc') != '') {

    Object.keys(Cookies.get()).forEach(function(cookie) {
      Cookies.remove(cookie);
    });
    Cookies.remove('igCountry', { path: '/'});
    Cookies.remove('igSplash', { path: '/'});

    var cookies = document.cookie.split("; ");
    for (var c = 0; c < cookies.length; c++) {
      var d = window.location.hostname.split(".");
      while (d.length > 0) {
        var cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
        var p = location.pathname.split('/');
        document.cookie = cookieBase + '/';
        while (p.length > 0) {
          document.cookie = cookieBase + p.join('/');
          p.pop();
        };
        d.shift();
      }
    }
    currentURL = window.location.href.split('?')[0];
    window.location.href = currentURL;
  }

  $('.search-main__button').on('click',function(e) {
    e.preventDefault();
    var myDiv = $(this).attr('href');
    $('.search-main__button').removeClass('active');
    $(this).addClass('active');
    $('.search-main__type').removeClass('active');
    $(myDiv).addClass('active');
  });

  $('.search-sidebar a').on('click',function(e) {
    e.preventDefault();
    if($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('ul').find('a').removeClass('active');
      $(this).addClass('active')
    }
    searchSidebarFilters();
  });
});

var resizeTimer;



var config = {
  debug: true,
  thmString: '?thm=XbBmFQ1wsg'
}
var wick = {
  init: function() {
    this.checkShopifyGeo();
    this.headerHeight();
  },
  checkShopifyGeo: function() {
    var countryTimer = setTimeout(function() {
      var shopifyCountry = wick.getCookie('_shopify_country');
      if(shopifyCountry) {
        clearInterval(countryTimer);
      }
    }, 250);
  },
  onPage: function(url) {
    var myHref = window.location.href;
    return myHref.indexOf(url) > -1
  },
  updateUrl: function(newUrl) {
    history.replaceState('', document.getElementsByTagName("title")[0].innerHTML, newUrl);
  },
  setCookie: function(n,v,x,p) {
    var d = new Date;
    d.setTime(d.getTime() + 24*60*60*1000*x);
    document.cookie = n + "=" + v + ";path=/;expires=" + d.toGMTString();
  },
  getCookie: function(c) {
    var v = document.cookie.match('(^|;) ?' + c + '=([^;]*)(;|$)');
    return v ? v[2] : false;
  },
  deleteCookie: function(n) {
    wick.setCookie(n,'',-1);
  },
  headerHeight: function() {
    var headHeight = $('.shopify-section-header').height();
    $('#MainContent').css('margin-top',headHeight);
  },
  thmCookie: function() {
    return Cookies.get('thm_valid') == 1;
  },
  thmParam: function() {
    var p = config.thmString;
    return window.location.href.indexOf(p) > -1;
  },
  showHoneyMudSignup: function(t) {
    if(!window.theme.thm.available && t == 'ohNo') {
      wick.ohNo();
    }
    $('.thm--form-wrapper').hide();
    $('.thm--signup-wrapper').fadeIn('slow');
    $('#product-add-bar').remove();

  },
  ohNo: function() {
    $('.thm--signup-wrapper .thm_p').text(window.theme.thm.signupTextSoldOut);
    $('.thm_submit').text(window.theme.thm.ohNoBtnText);
    $('#thm_signup--list-id').val(window.theme.thm.ohNoListId);
  },
  showHoneyMudForm: function() {
    $('.thm--signup-wrapper').hide();
    $('.thm--form-wrapper').fadeIn('slow');
  },
  addRemoveCookieButton: function() {
    if(!window.theme.admin) return;
    $('#product-top-level').prepend('<a style="position: absolute; top: 10px; left: 10px; font-size: 12px; width: auto; z-index: 5; display: none;" id="clear-thm-cookies" href="#" class="btn brown-btn">Clear THM Cookies</a>');
    $('#clear-thm-cookies').fadeIn('slow');
  },
  clearThmCookies: function() {
    $('#product-top-level').fadeTo('fast',0,function() {
      wick.deleteCookie('thm_valid');
      location.reload();
    });
  },
  checkHoneyMud: function() {
    if(wick.thmParam() && wick.thmCookie() == false) {
      wick.setCookie('thm_valid',1,365);
      var fullUrl = window.location.href;
      wick.updateUrl(fullUrl.replace(config.thmString,''));
    }
    if(wick.onPage('/products/the-honey-mud')) {
      if(wick.thmCookie()) {
        wick.showHoneyMudForm();
        window.theme.thm.available ? wick.showHoneyMudForm() : wick.showHoneyMudSignup('ohNo');
      } else {
        wick.showHoneyMudSignup();
      }
    }
    var $plpThm = $('.product[data-product-title="The Honey Mud"]');
  },
  checkThmInCart: function() {
    var thmMax = false;
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      async: false,
      success: function(data) {
        $.each(data.items,function(i,item) {
          if(item.handle == 'the-honey-mud' && item.quantity >= 2) {
            thmMax = true;
          }
        });
      }
    });
    return thmMax;
  },
  showThmPdpNote: function() {
    $('.thm--limit-wrapper-pdp').fadeIn();
  },
  postMessage: function (data, player) {
    var playerOrigin = "*",
        message = JSON.stringify(data);
    $(player)[0].contentWindow.postMessage(message, playerOrigin);
  },
  pauseYoutube: function (el) {
    $(el).removeClass("show");
    var data = {
      event: "command",
      func: "pauseVideo",
      args: ""
    };
    wick.postMessage(data, el);
  },
  playYoutube: function (el) {
    $(el).addClass("show");
    var data = {
      event: "command",
      func: "playVideo",
      args: ""
    };
    wick.postMessage(data, el);
  },
  iframeSrc: function (el) {
    if (!$(el).hasClass("loaded")) {
      $(el).attr("src", $(el).attr("data-src"));
      $(el).addClass("loaded");
    }
  },
  inView: function (t, p) {
    if ($(t).length) {
      var n = $(window).scrollTop(),
          o = n + $(window).height(),
          e = $(t).offset().top,
          l = e + $(t).height();
      return !0 === p ? n < e && l < o : e <= o && n <= l;
    }
  },
  playVideo: function(el) {
    var video = $(el)[0];
    var isPlaying = video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;
    if (!isPlaying) {
      video.play();
      $(el).addClass('video--playing');
    }
  },
  pauseVideo: function(el) {
    $(el).removeClass('video--playing');
    $(el)[0].pause();

  },
  fancyTooltips: function() {
    var $tt = $('[data-fancy-tooltip]');
    $tt.each(function() {
      var $t = $(this);
      var tipData = $t.data('fancy-tooltip');
      var $tip = $('<div class="wicktip"><div class="flex"></div></div>');
      $t.hover(function() {
        /* in  */
      },function() {
        /* out */
      });
    });
    /* Not sure who added these, but...for the sake of cleanliness */
    var $fancyTooltip = $('.fancy-tooltip');
    if($fancyTooltip.length && $fancyTooltip.offset().left < 10){
      $fancyTooltip.offset({left: 10});
    }
  },
  hideSlideOnMobile: function(event,slick) {
    console.log(slick);
    if($(slick.$slider).find('.hide-on-mobile').length == 0) return;
    console.log('wick.hideSlideOnMobile');
    if (!window.slickIsChanging) {
      window.slickIsChanging = true;
      if(slick.activeBreakpoint && slick.activeBreakpoint <= window.breakpointMobile) {
        if(!window.slickIsFiltered) {
          slick.slickFilter(':not(.hide-on-mobile)');
          window.slickIsFiltered = true;
        }
      } else {
        if(window.slickIsFiltered) {
          slick.slickUnfilter();
          window.slickIsFiltered = false;
        }
      }
      window.slickIsChanging = false;
    }
  },
  slickSliders: function() {
    var isChanging = false,
        breakpointMobile = 768,
        isFiltered = false;

    window.breakpointMobile = 768;
    window.slickIsChanging = false;
    window.slickIsFiltered = false;

    var $lick = $('[data-slick]');

    $lick.on('init',function(s,slick) {
      $(s.target).fadeIn('slow');
      wick.hideSlideOnMobile(s,slick);
    });

    $lick.on('breakpoint',function(event,slick) {
      wick.hideSlideOnMobile(event,slick);
    });

    $lick.each(function(i,slick) {
      $(slick).slick();
    });

    $lick.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      var $currSlideObj = $lick.find('[data-slick-index="'+currentSlide+'"]');
      var $nextSlideObj = $lick.find('[data-slick-index="'+nextSlide+'"]');

      var videoPlayer = '.plyr-video';
      if($currSlideObj.find(videoPlayer).length) {
        $currSlideObj.find(videoPlayer)[0].pause();
      }
      if($nextSlideObj.find(videoPlayer).length) {
        $nextSlideObj.find(videoPlayer)[0].play();
      }

    });
  },
  goToSlide: function(slider,idx) {
    var slideno = parseFloat(idx);
    $(slider).slick('slickGoTo', slideno);
  }
};


wick.stopAllVideos = function() {
  $.each(window.players,function(i,v) {
    window.players[i].stop();
    window.players[i].currentTime = 0;
    v.currentTime = 0;
    v.stop();
  });
}
wick.playThisPlyr = function(id) {
  wick.stopAllVideos();
  console.log(window.players);
  $.each(window.players,function(i,v) {
    if($(v.elements.original).attr('id') == id) {
      v.currentTime = 0;
      v.play();
      return
    }
    if(v.elements.original.id == id) {
      window.players[i].currentTime = 0;
      window.players[i].play();
      return;
    }
  });
};

wick.oneVideoAtATime = function() {
  console.log(window.players);
  if(window.players) {
    window.players.forEach(function (instance) {
      instance.on('play', function (event) {
        var currentPid = instance.id;
        window.players.forEach(function (instance) {
          if (currentPid != instance.id) {
            instance.stop();
          }
        });
      });
    });
  }
};

theme.scrollTo = function(el,offset) {
  if($(el).length == 0) return;
  offset = offset || 0;
  $('html,body').animate({
    scrollTop: ($(el).offset().top - $('.shopify-section-header').outerHeight() - offset)
  }, 500);
};

$(function() {
  wick.init();
  theme.mfpSetup();
  wick.slickSliders();

  window.players = Plyr.setup('.plyr-video');

  $(document).on('click','#clear-thm-cookies',function() {
    wick.clearThmCookies();
    return false;
  });

  if(theme.isIpad()) {
    $('#main-link--gift-card').hide();
  }
});

$(window).on('load,resize',function() {
  wick.headerHeight();
});

  $(document).ready(function(){
    $('.marketing-quotes-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
      dots: true,
      draggable: true
    });
  });



